import { render, staticRenderFns } from "./ChatJanela.vue?vue&type=template&id=0a25ce3e&scoped=true"
import script from "./ChatJanela.vue?vue&type=script&lang=js"
export * from "./ChatJanela.vue?vue&type=script&lang=js"
import style0 from "./ChatJanela.vue?vue&type=style&index=0&id=0a25ce3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a25ce3e",
  null
  
)

export default component.exports